Vendd.Scripts.load(function () {
    var $wrapper = $('.x-searchbox');

    if ($wrapper.length < 1 || $wrapper.hasClass('elastic'))
        return;

    $.each($wrapper, function (i, wrapper) {
        var $wrapper = $(wrapper);

        var lookup = true;
        var $input = $('.js-keyword', $wrapper);
        var $button = $('.js-submit', $wrapper);
        var toggleButton = $('.js-search-toggle', $wrapper);
     
        var minLength = $wrapper.data('min-search-length');
        var filtered = $wrapper.data('product-categories-filter');
        var mask = $wrapper.data('mask');
        var showOnlyProducts = $wrapper.data('only-products');
        var ajax = $wrapper.data('ajax');
        if (typeof (ajax) == 'string')
            ajax = $wrapper.data('ajax').toLowerCase() === 'true';
        var lazy = false;

        var $category, $suggestive;
        var model = null;

        if (filtered) {
            $category = $('.js-search-category', $wrapper);

            $category.change(function (e) {
                if (ajax) {
                    wrapper.showList(false);
                };

                wrapper.clearValue();
            });
        };

        if (ajax) {
            $suggestive = $(".x-suggestive-results-list", $wrapper);

            if ($suggestive.length <= 0)
                throw 'Error: Suggestive List does not exist';

            lazy = $suggestive.data("lazy-load-init");

        	//Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsFailed, wrapper, function (envelope) {
        	Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetSuggestiveResultsFailed, wrapper, function (envelope) {
                wrapper.loading(false);
            });
        	
        	//Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetProductSuggestiveResultsSuccess, wrapper, function (envelope) {
        	Vendd.MessageBus.subscribe(Vendd.Search.Messages.GetSuggestiveResultsSuccess, wrapper, function (envelope) {
                model = envelope.message.data.model;

                model = wrapper.transformData(model);
                /* Track Search & SearchTerm */
                if (typeof fbPixelTracker !== 'undefined' && typeof fbPixelCanTrack !== 'undefined') {
                    if (fbPixelTracker && fbPixelTracker.Properties.FacebookPixelId && fbPixelCanTrack) {
                        fbq('track', 'Search');
                        fbq('trackCustom', 'SearchTerm', { search_string: $input });
                    }
                }
                /* END Track Search & SearchTerm */

                if (showOnlyProducts) {
                    mask = model.SearchProductsUrl; // SOS has been add to change to url from Search to Search Products
                }
                var html = Vendd.Handlebars.parse("suggestiveResultList", model);

            	$suggestive.html(html);           

                wrapper.showList(true);
                wrapper.loading(false);
                formatPrices($suggestive);
            });
        };

        wrapper.loading = function (loading) {
            if (loading) {
                $wrapper.addClass('x-loading').addClass('x-disabled');
            } else {
                $wrapper.removeClass('x-loading').removeClass('x-disabled');
            };
        };

        wrapper.clearValue = function () {
            $input.val("");
        };

        wrapper.showList = function (show) {
            if (ajax && $suggestive.length > 0) {
                if (show) {
                    $suggestive.addClass("js-visible");
                    $('.site-overlay').addClass('visible');
                } else {
                    $suggestive.removeClass("js-visible");
                    $('.site-overlay').removeClass('visible');
                };
            }
        };

        wrapper.submit = function () {
            if (mask == '')
                return;

            var text = $input.val();
            var targetUrl = mask.replace("((search))", text);
            if (showOnlyProducts)
                targetUrl = targetUrl.replace('/search/', '/search-products/');

            if (filtered) {
                var categoriesFilter = $category.val() ? $category.val() : "";

                if (categoriesFilter !== "") {
                    targetUrl = targetUrl.replace("((category))", categoriesFilter);
                } else {
                    targetUrl = LhApp.Function.Url.removeParameterFromUrl(targetUrl, 'Category');  // chriss TODO
                }
            }

            document.location = targetUrl;
        };

        wrapper.expand = function () {
            if ($wrapper.hasClass('expanded')) {
                $wrapper.removeClass('expanded');
            } else {
                $wrapper.addClass('expanded');
                $input.focus();
            }

        };

        $button.click(function (e) {
            if ($input.val().length >= minLength && lookup) {
                e.preventDefault();

                wrapper.loading(true);
                wrapper.submit();
            };
        });

        toggleButton.click(function (e) {
            wrapper.expand();
        });
        
        $input.keyup($.debounce(850, function (e) {
            var searchTerm = $input.val();
            var category = filtered ? $category.val() : "";

            if ($input.val().length >= minLength) {
                if (ajax) {
                    wrapper.loading(true);
                    wrapper.showList(true);
                    
                    //Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetProductSuggestiveResults(searchTerm, 200));
                    Vendd.MessageBus.publishAsync(wrapper, new Vendd.Search.Messages.GetSuggestiveResults(searchTerm, category));
                };
            } else {
                wrapper.showList(false);
            };
        }));

        $input.keyup(function (e) {
            if (e.keyCode === 13) {
                e.stopPropagation();
                e.preventDefault();

                $button.trigger("click");
            };
        });
        /*
        $wrapper.hover(
            function () {
                if ($input.val().length >= minLength && ajax) {
                    wrapper.showList(true);
                } else {
                    wrapper.showList(false);
                }
            },
            function () {
                wrapper.showList(false);
            }
        );
        */

        var hideEvent;
        var delay = isTouch() ? 0 : 200;
        $wrapper.hover(
            function () {
                clearTimeout(hideEvent);
                if ($input.val().length >= minLength && ajax) {
                    wrapper.showList(true);
                } else {
                    wrapper.showList(false);
                }
            },
            function () {
                hideEvent = setTimeout(function () {
                    wrapper.showList(false);
                }, delay);
            }
        );
       
        toggleButton.hover(
            function (e) {
                e.stopPropagation();
                wrapper.showList(false);
            },
            function () {
                if ($input.val().length >= minLength && ajax) {
                    if ($wrapper.is(':hover')) {
                        wrapper.showList(true);
                    }
                }
            }
        );
        
        $(document).on('click', function (e) {
            if (!$wrapper.is(e.target) && $wrapper.has(e.target).length === 0) {
                $wrapper.removeClass('expanded');
            }
        });

        wrapper.transformData = function (model) {
            if (!model) return model;
            for (var i = 0; model.Products && i < model.Products.length; i++) {
                model.Products[i].NotForSale = model.Products[i].AvailabilityActionId == 9;
            }

            if (model.Products && model.Products.length > 5) {
                model.Products.splice(5, model.Products.length);
                model.MoreProducts = true;
            }
            if (model.Manufacturers && model.Manufacturers.length > 0) {
                model.Manufacturers = null;
                model.ManufacturersCount = 0;
            }
            if (model.Categories && model.Categories.length > 0) {
                model.Categories = null;
                model.CategoriesCount = 0;
            }
            if (model.Categories && model.Categories.length > 9) {
            	model.Categories.splice(9, model.Categories.length);
            	model.CategoriesCount = 9;
            	model.MoreCategories = true;
            }

            model.ItemsCount = model.ProductsCount;// + model.CategoriesCount;
            return model;
        }
    });
});